import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import Cookies from "js-cookie";
import App from './App';


const gaTrackingId = "G-KRVJG4LMSD";

// Check if consent cookie exists and GA has not been initialized
if (Cookies.get("consent") && !window.gaInitialized) {
  ReactGA.initialize(gaTrackingId);
  window.gaInitialized = true;
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
